// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ServiceGroupsList_wrapper__3InYV","item":"ServiceGroupsList_item__PdFy4","header":"ServiceGroupsList_header__2G5wT"};